var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.04 23.39L16.052 23.397C18.24 24.79 21.1019 24.4761 22.936 22.642L23.71 21.868C24.4298 21.1473 24.4298 19.9797 23.71 19.259L20.449 16C19.7283 15.2802 18.5607 15.2802 17.84 16V16C17.4943 16.3461 17.0252 16.5406 16.536 16.5406C16.0468 16.5406 15.5777 16.3461 15.232 16L10.014 10.781C9.29418 10.0603 9.29418 8.89271 10.014 8.17199V8.17199C10.3601 7.8263 10.5546 7.35718 10.5546 6.86799C10.5546 6.37881 10.3601 5.90969 10.014 5.56399L6.754 2.29999C6.03328 1.58018 4.86572 1.58018 4.145 2.29999L3.371 3.07399C1.53728 4.90814 1.22303 7.76961 2.615 9.95799L2.623 9.96999C6.19641 15.2598 10.751 19.8154 16.04 23.39V23.39Z",
    stroke: "#758ABD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3ca3a072.svg";
export { ForwardRef as ReactComponent };